import React, { useEffect, useState } from "react";
import VideoPlayer from '../common/VideoPlayer';
import CardNewsGallery from '../common/CardNewsGallery';
import FeaturedVideo from './FeaturedVideo';
import ContentGallery from './ContentGallery';
import { FaBed } from 'react-icons/fa';
import './GuideLife_01.scss';

const GuideLife_01 = ({ 
sectionTitle = "교내 생활 안내",
sectionIcon = <FaBed />,
kickerText = "새내기 추천 영상",
subText = "캠퍼스에서의 일상을 보다 편리하고 풍요롭게 만들어 줄 생활 안내를 제공합니다.",
contents = []
}) => {

// 기본 콘텐츠 데이터
const defaultContents = [
    {
        id: "life-yt-1",
        type: "youtube",
        topic: "life",
        title: "기숙사 이용안내",
        url: "https://youtu.be/X_HtvoWvKZ0",
        thumb: "https://img.youtube.com/vi/X_HtvoWvKZ0/maxresdefault.jpg",
        desc: "입사 전 꼭 알아야 할 기숙사 기본 이용법을 빠르게 정리했어요.",
        featured: true,
    },
    {
        id: "life-yt-2",
        type: "youtube",
        topic: "life",
        title: "교내 식당 및 편의시설 이용안내",
        url: "https://youtu.be/zhdIOvSZ-4U",
        thumb: "https://img.youtube.com/vi/zhdIOvSZ-4U/maxresdefault.jpg",
        desc: "식당/편의시설을 이용하는 방법을 한 번에 정리했어요.",
    },
    {
        id: "life-yt-3",
        type: "youtube",
        topic: "life",
        title: "상담경력개발센터 안내",
        url: "https://youtu.be/1nBZyJrJJ9c",
        thumb: "https://img.youtube.com/vi/1nBZyJrJJ9c/maxresdefault.jpg",
        desc: "학업 상담부터 진로 설계, 취업 지원까지!",
    },
    {
        id: "life-yt-4",
        type: "youtube",
        topic: "life",
        title: "도서관 이용안내",
        url: "https://youtu.be/oIsVkeernPU",
        thumb: "https://img.youtube.com/vi/oIsVkeernPU/maxresdefault.jpg",
        desc: "GIST 도서관 이용 방법을 한 번에 정리했어요.",
    },
    {
        id: "life-cn-1",
        type: "cardnews",
        topic: "life",
        title: "기숙사 체크리스트 카드뉴스",
        thumb: "/images/guide/001.png",
        desc: "준비물/규칙/자주 묻는 질문을 한 번에 정리!",
        images: ["/images/guide/001.png","/images/guide/002.png", "/images/guide/003.png", "/images/guide/004.png", "/images/guide/005.png"],
    },
    {
        id: "life-cn-2",
        type: "cardnews",
        topic: "life",
        title: "Study in GIST",
        thumb: "/images/guide/01.png",
        desc: "GIST 스터디공간을 한 번에 정리!",
        images: ["/images/guide/01.png",
        "/images/guide/02.png",
        "/images/guide/03.png",
        "/images/guide/04.png",
        "/images/guide/05.png",
        "/images/guide/06.png",
        "/images/guide/07.png",
        "/images/guide/08.png",
        "/images/guide/09.png",
        ],
    },
    {
        id: "life-cn-3",
        type: "cardnews",
        topic: "life",
        title: "GIST 체육시설",
        thumb: "/images/guide/1.png",
        desc: "GIST 체육시설을 한 번에 정리!",
        images: ["/images/guide/1.png",
        "/images/guide/2.png",
        "/images/guide/3.png",
        "/images/guide/4.png",
        "/images/guide/5.png",
        "/images/guide/6.png",
        "/images/guide/7.png",
        "/images/guide/8.png",
        "/images/guide/9.png",
        "/images/guide/10.png",
        "/images/guide/11.png",
        "/images/guide/12.png",
        "/images/guide/13.png",
        ],
    },
    {
        id: "life-cn-4",
        type: "cardnews",
        topic: "life",
        title: "Weight in GIST",
        thumb: "/images/guide/14.png",
        desc: "GIST에서 운동 많이 된다.",
        images: ["/images/guide/14.png",
        "/images/guide/15.png",
        "/images/guide/16.png",
        "/images/guide/17.png",
        "/images/guide/18.png",
        "/images/guide/19.png",
        "/images/guide/20.png",
        "/images/guide/21.png",
        "/images/guide/22.png",
        "/images/guide/23.png",
        "/images/guide/24.png",
        "/images/guide/25.png",
        ],
    },
    {
        id: "life-cn-5",
        type: "cardnews",
        topic: "life",
        title: "카페 모음.zip",
        thumb: "/images/guide/26.png",
        desc: "GIST의 모든 카페를 한 곳에 모으다!",
        images: ["/images/guide/26.png",
                "/images/guide/27.png",
                "/images/guide/28.png",
                "/images/guide/29.png",
                "/images/guide/30.png",
                "/images/guide/31.png",
                "/images/guide/32.png",
                "/images/guide/33.png",
                "/images/guide/34.png",
                "/images/guide/35.png",
                "/images/guide/36.png",
                "/images/guide/37.png",
                "/images/guide/38.png",
                ],
    },
];

// props로 받은 contents가 있으면 사용, 없으면 기본 데이터 사용
const displayContents = contents.length > 0 ? contents : defaultContents;

// ✅ 모달
const [selected, setSelected] = useState(null);

const openContent = (c) => {
    setSelected(c);
};

const closeModal = () => {
    setSelected(null);
};

// ESC 키로 모달 닫기
useEffect(() => {
    const onKeyDown = (e) => {
    if (e.key === "Escape") closeModal();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
}, []);

// featured content 찾기
const featuredContent = displayContents.find((c) => c.topic === "life" && c.featured && c.type === "youtube") ||
    displayContents.find((c) => c.topic === "life" && c.type === "youtube") ||
    null;




//=====================================================================
return (
    <div className="GuideLife_container">
        <div className="hub-container">
            <h3 className="section-title">
            <span className="section-icon">{sectionIcon}</span>
            {sectionTitle}
            </h3>

            <div className="hub">
            <FeaturedVideo 
                kicker={kickerText}
                sub={subText}
                featured={featuredContent}
                onOpenContent={openContent}
            />
            
            <ContentGallery 
                contents={displayContents.filter((c) => c.topic === "life")}
                onOpenContent={openContent}
            />
            </div>
        </div>

    {/* ✅ Modal */}
    {selected && selected.type === "youtube" && (
        <VideoPlayer
        url={selected.url}
        title={selected.title}
        onClose={closeModal}
        />
    )}
    
    {selected && selected.type === "cardnews" && (
        <CardNewsGallery
        images={selected.images}
        title={selected.title}
        onClose={closeModal}
        />
    )}
    </div>
);
};

export default GuideLife_01;